import { AxiosResponse } from "axios";
import {
  UpsertWalletRequestDTO,
  WalletDetailsResponse,
} from "../@types/Wallet";
import {
  getWalletInsights,
  getWalletInsightsB3,
  dispatchQueueB3,
  dispatchQueue,
  addAsset,
  removeAsset,
  getWalletDetails,
  upsertWallet,
  upsertWalletDataB3,
} from "../services/wallet";
export default function useWallet() {
  function getInsights(): Promise<AxiosResponse> {
    return getWalletInsights();
  }

  function getInsightsB3(): Promise<AxiosResponse> {
    return getWalletInsightsB3();
  }

  async function dispatchToQueue(): Promise<boolean> {
    const status = await dispatchQueue();

    return status === 200;
  }

  async function dispatchToQueueB3(): Promise<boolean> {
    const status = await dispatchQueueB3();

    return status === 200;
  }

  function addAssetByEncodedId(encodedId: string): Promise<number> {
    return addAsset(encodedId);
  }

  function removeAssetByEncodedId(encodedId: string): Promise<number> {
    return removeAsset(encodedId);
  }

  function getWalletData(): Promise<WalletDetailsResponse | null> {
    return getWalletDetails();
  }

  async function upsertWalletData(
    dto: UpsertWalletRequestDTO
  ): Promise<boolean> {
    const statusCode = await upsertWallet(dto);

    return statusCode === 201;
  }

  async function upsertWalletB3(
    file: File,
    tolerance: string
  ): Promise<number> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("tolerance", tolerance);

    const statusCode = await upsertWalletDataB3(formData);

    return statusCode;
  }

  return {
    getInsights,
    getInsightsB3,
    dispatchToQueue,
    dispatchToQueueB3,
    addAssetByEncodedId,
    removeAssetByEncodedId,
    getWalletData,
    upsertWalletData,
    upsertWalletB3,
  };
}
